import { Box, Typography } from '@mui/material';

export const busFieldSize = { xs: 12, sm: 6, lg: 4 };
export function BusFormSection({ title, children }) {
  return <Box component="section" aria-label={title} sx={{ minWidth: 0, bgcolor: '#fff', border: '1px solid #E2E8F0', borderRadius: '12px', p: 2, boxShadow: '0 2px 6px #12304708' }}>
    <Typography component="h2" sx={{ fontSize: 15, fontWeight: 700, color: '#123047', mb: 2, pb: 1.25, borderBottom: '1px solid #E2E8F0' }}>{title}</Typography>
    {children}
  </Box>;
}
export const busFormSx = {
  minWidth: 0,
  '& .MuiOutlinedInput-root': { borderRadius: '8px', minHeight: 46, bgcolor: '#fff', fontSize: 14 },
  '& .MuiOutlinedInput-input': { py: 1.5 },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2563EB' },
  '& .MuiInputLabel-root': { fontSize: 14 },
  '& .MuiButton-root': { textTransform: 'none', borderRadius: '9px', fontWeight: 600 },
  '& .MuiButton-containedPrimary': { bgcolor: '#2563EB', '&:hover': { bgcolor: '#1D4ED8' } },
  '& .MuiButton-root:focus-visible': { outline: '3px solid #93B4FA', outlineOffset: 2 },
};
